
const digest = '2817b293ea8d2573faf4517fcfd249e7d7f77dbb761a4419ce026f516580cba0';
const classes = {"wrapper":"_wrapper_j0ajd_1","title":"_title_j0ajd_13"};
const css = `._wrapper_j0ajd_1 {
  font-family: Rubik, "sans-serif";
  background: #ffffff;
  border-radius: 15px;
  padding: 16px 24px;
  box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_j0ajd_1 ._title_j0ajd_13 {
  font-size: 16px;
  font-weight: 600;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  